import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-ship-view-table',
  templateUrl: './ship-view-table.component.html',
  styleUrls: ['./ship-view-table.component.scss'],
})
export class ShipViewTableComponent {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('table', { static: false }) table!: ElementRef;
  elements: any;
  paginatedData: any[] = [];
  itemsPerPage: number = 15;
  currentPage: number = 0;
  rowData: any;
  counter = 1;
  conditionOptions = ['Laden', 'Ballast'];
  filteredData: any;
  visible:boolean=false
  constructor(
    private router: Router,
    private toastr: ToastrService,
  ) {
   
  }
  ngOnInit() {
    
  }
  toggleMapView() {
    this.visible = !this.visible;
  }
}
